import React, { useState } from "react";
import SelectProgram from "../components/SelectProgram";
import { Col, Container, Row } from "reactstrap";
import Import from "./components/Import";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
const CsvImport = () => {
  return (
    <div className="referral">
      <Container>
        <Row className="mt-4">
          <Col md={12}>
            <div className="my-3 d-flex justify-content-between">
              <h3>CSV Import</h3>
            </div>
          </Col>
          <Col md={6} className="d-flex program-select my-3 flex-wrap text-start">
            <div md={6} className="w-100">
            <div className="d-flex align-items-center">
                <h5 className="mb-1 d-flex align-items-center">
                    Program

                    <Tooltip
                    title="Choose the program where users and data will be imported."
                    arrow
                    placement="right"
                    >
                    <IconButton size="small" style={{ padding: 4, marginLeft: 6 }}>
                        <InfoOutlinedIcon fontSize="small" />
                    </IconButton>
                    </Tooltip>

                </h5>
            </div>


            <small>Select the program you want to import to</small>
            </div>
            <div md={6}  className="w-100 mt-2">
            <SelectProgram label=""/>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            {/* <h6 className="bg-primary p-2 rounded text-white my-4 text-center ">
              Select Import Type and .csv File
            </h6> */}
            <div className="my-3 d-flex bg-muted mt-0">
              <Import />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CsvImport;
